import React, { useEffect, useState } from "react";
import { IoClose } from "react-icons/io5";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { vipTour } from "../config/config";
import { toast } from "react-hot-toast";
import { IoCloseCircleSharp } from "react-icons/io5";

const VipTour = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    full_name: "",
    mobile: "",
    email: "",
    vehicle: "1", // 'vip' or 'private'
  });
  const [isInfoOpen, setIsInfoOpen] = useState(true);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(vipTour.url, {
        method: vipTour.method,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      const data = await response.json();
      if (response.status === 200) {
        toast.success(data.message);
        setFormData({
          full_name: "",
          mobile: "",
          email: "",
          vehicle: "1", // 'vip' or 'private'
        });
        onClose();
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Failed to submit form");
    }
  };

  return (
    <div className="fixed inset-0 z-[99999] vip_tour_modal flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div className="relative border-[#fdd400] border-[5px] w-full max-w-2xl rounded-lg bg-white shadow-xl animate-in fade-in zoom-in duration-300 max-h-[90vh] overflow-y-auto">
        <div class="vip_header">
            <span>VIP tour</span> 
            <button
              onClick={onClose}
              className="text-[#442202] lg:text-[26px] text-[22px] cursor-pointer"
            >
              <IoCloseCircleSharp />
            </button>
        </div>
        <div className="p-6 relative">
          <form onSubmit={handleSubmit} className="mt-2 text-[#442202]">
            {/* Top Form Section */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
              <div>
                <label className="block text-sm font-semibold mb-1">
                  Full Name *
                </label>
                <input
                  type="text"
                  name="full_name"
                  value={formData.full_name}
                  onChange={handleChange}
                  placeholder="Full Name"
                  className="w-full border border-[#442202] rounded-full px-4 py-2 focus:outline-none focus:ring-1 focus:ring-[#fbba00]"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-semibold mb-1">
                  Mobile Number *
                </label>
                <input
                  type="tel"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  placeholder="Mobile Number"
                  className="w-full border border-[#442202] rounded-full px-4 py-2 focus:outline-none focus:ring-1 focus:ring-[#fbba00]"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-semibold mb-1">
                  Email *
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email"
                  className="w-full border border-[#442202] rounded-full px-4 py-2 focus:outline-none focus:ring-1 focus:ring-[#fbba00]"
                  required
                />
              </div>
            </div>

            {/* Tour Type Selection */}
            <div className="flex gap-6 mb-6">
              <label className="flex items-center gap-2 cursor-pointer font-bold">
                <input
                  type="radio"
                  name="vehicle"
                  value="1"
                  checked={formData.vehicle === "1"}
                  onChange={handleChange}
                  className="accent-[#442202] w-5 h-5 border-2 border-[#442202]"
                />
                VIP Tour
              </label>
              <label className="flex items-center gap-2 cursor-pointer font-bold">
                <input
                  type="radio"
                  name="vehicle"
                  value="2"
                  checked={formData.vehicle === "2"}
                  onChange={handleChange}
                  className="accent-[#442202] w-5 h-5 border-2 border-[#442202]"
                />
                Private Tour
              </label>
            </div>

            {/* Info Accordion */}
            <div className="border border-[#442202] rounded-lg overflow-hidden mb-6">
              <button
                type="button"
                onClick={() => setIsInfoOpen(!isInfoOpen)}
                className="w-full flex items-center justify-between bg-[#442202] text-[#fbba00] px-4 py-3 font-bold text-lg"
              >
                <span>Information about VIP & PRIVATE TOUR</span>
                {isInfoOpen ? <FaChevronUp /> : <FaChevronDown />}
              </button>

              {isInfoOpen && (
                <div className="p-4 bg-white text-sm leading-relaxed">
                  <div className="mb-6">
                    <h3 className="font-bold text-lg mb-2">VIP tour:</h3>

                    <p className="font-semibold mb-2">
                      Option 1:(2 hours course)(¥30000 per person)(Starting point
                      would be Monkey Adventure kart Shinagawa shop-Route 3)
                    </p>
                    <div className="flex flex-wrap gap-y-2 gap-x-6 mb-4">
                      <span className="flex items-center gap-2">
                        <span className="w-3 h-3 rounded-full bg-[#442202]"></span>
                        Rainbow bridge
                      </span>
                      <span className="flex items-center gap-2">
                        <span className="w-3 h-3 rounded-full bg-[#442202]"></span>
                        Harajuku
                      </span>
                      <span className="flex items-center gap-2">
                        <span className="w-3 h-3 rounded-full bg-[#442202]"></span>
                        Roppongi
                      </span>
                      <span className="flex items-center gap-2">
                        <span className="w-3 h-3 rounded-full bg-[#442202]"></span>
                        Tokyo tower
                      </span>
                      <span className="flex items-center gap-2">
                        <span className="w-3 h-3 rounded-full bg-[#442202]"></span>
                        Shibuya crossing
                      </span>
                      <span className="flex items-center gap-2">
                        <span className="w-3 h-3 rounded-full bg-[#442202]"></span>
                        Omotesando
                      </span>
                      <span className="flex items-center gap-2">
                        <span className="w-3 h-3 rounded-full bg-[#442202]"></span>
                        Odaiba city
                      </span>
                    </div>

                    <p className="font-semibold mb-2">
                      Option 2: (2 hours)(¥26000 per person)(Starting point would
                      be Monkey Adventure kart Asakusa shop-Route 1)
                    </p>
                    <div className="flex flex-wrap gap-y-2 gap-x-6">
                      <span className="flex items-center gap-2">
                        <span className="w-3 h-3 rounded-full bg-[#442202]"></span>
                        Asakusa Skytree
                      </span>
                      <span className="flex items-center gap-2">
                        <span className="w-3 h-3 rounded-full bg-[#442202]"></span>
                        Sensoji- Temple
                      </span>
                      <span className="flex items-center gap-2">
                        <span className="w-3 h-3 rounded-full bg-[#442202]"></span>
                        Akihabara
                      </span>
                      <span className="flex items-center gap-2">
                        <span className="w-3 h-3 rounded-full bg-[#442202]"></span>
                        Tokyo imperial palace
                      </span>
                      <span className="flex items-center gap-2">
                        <span className="w-3 h-3 rounded-full bg-[#442202]"></span>
                        Ginza
                      </span>
                    </div>
                  </div>

                  <hr className="border-gray-300 my-4" />

                  <div>
                    <h3 className="font-bold text-lg mb-2">Private Tour:</h3>
                    <p className="mb-4">
                      If you're interested in a private tour, where it's just you
                      and your group with your personal tour guide, here are the
                      pricing options.
                    </p>
                    <p className="font-bold mb-1">
                      Price for Monkey Adventure Kart Asakusa Shop(Private Tour):
                      ¥20000 per person(1 hour tour)
                    </p>
                    <p className="font-bold">
                      Price for Monkey Adventure kart Shinagawa Shop(Private Tour):
                      ¥25000 per person(1 hour 30 minutes tour)
                    </p>
                  </div>
                </div>
              )}
            </div>

            <div className="text-center">
              <button
                type="submit"
                className="bg-[#442202] text-white px-10 py-3 rounded-full cursor-pointer font-bold text-lg hover:bg-[#5d2f03] transition-colors"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
        {/* Backdrop click to close */}
        <div className="absolute inset-0 -z-10" onClick={onClose}></div>

      </div>

    </div>
  );
};

export default VipTour;
